import bake from './light/bake.js'

var light = {
  bake: bake.bakePreview,
  bakeLoRes: bake.bakePreview,
  bakeHiRes: bake.bakeRegular
}

export default light